import React from 'react';
import { motion } from 'framer-motion';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <motion.footer 
            className="footer"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
        >
            <div className="footer-content">
                <div className="footer-section">
                    <h4>Connect</h4>
                    <div className="social-links">
                        <motion.a 
                            href="https://github.com/parhammhe" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <span role="img" aria-label="github">👨‍💻</span> GitHub
                        </motion.a>
                        <motion.a 
                            href="https://www.linkedin.com/in/parhammh/" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <span role="img" aria-label="linkedin">💼</span> LinkedIn
                        </motion.a>
                        <motion.a 
                            href="mailto:parhammoe@ieee.org"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            <span role="img" aria-label="email">📧</span> Email
                        </motion.a>
                    </div>
                </div>
                <div className="footer-section">
                    <h4>Quick Links</h4>
                    <div className="quick-links">
                        <motion.a 
                            href="#projects"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Projects
                        </motion.a>
                        <motion.a 
                            href="#publications"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Publications
                        </motion.a>
                        <motion.a 
                            href="#contact"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.95 }}
                        >
                            Contact
                        </motion.a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>© {currentYear} Parham Mohammadi. All rights reserved.</p>
            </div>
        </motion.footer>
    );
};

export default Footer; 